import React, { createContext } from "react";

import useWhatsApps from "../../hooks/useWhatsApps";

const WhatsAppsContext = createContext();

const WhatsAppsProvider = ({ children }) => {
       const { loading, whatsApps, setSessionStatus } = useWhatsApps();

	return (
               <WhatsAppsContext.Provider value={{ whatsApps, loading, setSessionStatus }}>
			{children}
		</WhatsAppsContext.Provider>
	);
};

export { WhatsAppsContext, WhatsAppsProvider };
